module.exports = __webpack_public_path__ + "img/checkbox-lg.b7513b75.svg";